"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageActionsProvider = exports.usePageActions = exports.usePageLoadMetrics = exports.getResultFromActionData = exports.PageActionsContext = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var LoggerFactory_1 = require("../utils/LoggerFactory");
var MetricsContext_1 = require("../MetricsContext");
var sli_metrics_client_1 = require("@cvent/sli-metrics-client");
var storage_1 = require("./storage");
var LOG = LoggerFactory_1.LoggerFactory.create('PageActions');
var noop = function () { return undefined; };
/**
 * Provide a default context so that the hook can be used in jest or if
 * page load metrics are disabled
 */
exports.PageActionsContext = React.createContext({
    track: noop,
    updateMetricData: noop,
    trackAction: noop,
    startAction: noop,
    endAction: noop,
    trackKeepAlive: noop,
    actionsRef: {},
    getBaseProps: noop,
    measureAction: noop,
    recordAction: noop,
    measureSLI: noop,
    trackSLI: noop
});
/**
 * Checks if this action needs to be tracked as success | error | expected_error
 * @param data
 * @returns
 */
var getResultFromActionData = function (data) {
    var _a = data || {}, _b = _a.error, error = _b === void 0 ? null : _b, _c = _a.expectedError, expectedError = _c === void 0 ? null : _c, _d = _a.expected_error, expected_error = _d === void 0 ? null : _d, _e = _a.incompleteMeasure, incompleteMeasure = _e === void 0 ? null : _e, _f = _a.incomplete_measure, incomplete_measure = _f === void 0 ? null : _f;
    var result = !error ? 'success' : 'error';
    var error_message = error;
    // Look if we should track it as an expected error
    if (expectedError || expected_error) {
        result = 'expected_error';
        // Set the error_message using the expected error string
        error_message = expectedError || expected_error;
        delete data['expectedError'];
        delete data['expected_error'];
        delete data['error'];
    }
    else if (incompleteMeasure || incomplete_measure) {
        result = 'incomplete_measure';
        // Set the error_message using the incomplete measure string
        error_message = incompleteMeasure || incomplete_measure;
        delete data['incompleteMeasure'];
        delete data['incomplete_measure'];
        delete data['error'];
    }
    return { result: result, error_message: error_message };
};
exports.getResultFromActionData = getResultFromActionData;
/**
 *
 * @deprecated usePageLoadMetrics has been deprecated and will be removed in the next release. Use usePageActions instead
 */
var usePageLoadMetrics = function () { return (0, react_1.useContext)(exports.PageActionsContext); };
exports.usePageLoadMetrics = usePageLoadMetrics;
var usePageActions = function () { return (0, react_1.useContext)(exports.PageActionsContext); };
exports.usePageActions = usePageActions;
var PageActionsProvider = function (_a) {
    var children = _a.children, _b = _a.getPersistedDataCallback, getPersistedDataCallback = _b === void 0 ? storage_1.getPersistedData : _b, _c = _a.setPersistedDataCallback, setPersistedDataCallback = _c === void 0 ? storage_1.savePersistedData : _c;
    var _d = (0, MetricsContext_1.useMetrics)(), measureEvent = _d.measureEvent, trackEvent = _d.trackEvent, getClientBaseProps = _d.getBaseProps;
    var eventListenersRef = (0, react_1.useRef)({});
    var metricEventsRef = (0, react_1.useRef)({});
    var metricsEventsOptionsRef = (0, react_1.useRef)({});
    var additionalData = (0, react_1.useRef)(getPersistedDataCallback() || {});
    /**
     * Make sure consumers are not using any reserved words
     * @param data
     */
    var checkReservedWords = function (data) {
        if (data === null || data === void 0 ? void 0 : data.type) {
            LOG.warn('You are passing `type` as an attribute of your action data which is a reserved word. This attribute has been removed to avoid conflicts');
            delete data.type;
        }
    };
    /**
     * Method to check if we can record the metric for the event provided.
     */
    var recordMetric = (0, react_1.useCallback)(function (result, data, eventName, options, callback) {
        if (result === void 0) { result = 'success'; }
        var LOGGER = LOG;
        var message = "finished measuring ".concat(eventName, " action, [").concat(result, "][").concat(data === null || data === void 0 ? void 0 : data.type, "]");
        if (!(data === null || data === void 0 ? void 0 : data.skip))
            LOGGER.debug(message);
        // Grab the metrics client using the eventName
        var metric = metricEventsRef.current[eventName];
        if (metric) {
            var defaultType = result === 'success' ? 'tracked' : 'not_tracked';
            metric.record(result, __assign({ type: defaultType }, data), options || {});
            delete metricEventsRef.current[eventName];
        }
        else {
            LOGGER.debug("Could not record ".concat(eventName, " action. Metric instance not found for the given action name"));
        }
    }, []);
    /**
     * Measure an action
     * NOTE: url and pathname must be present in data
     */
    var measure = (0, react_1.useCallback)(function (event, data, callback, options) {
        var metric = metricEventsRef.current[event];
        if (!metric) {
            LOG.debug("Measuring ".concat(event, " action for => ").concat(data.url || data.screenName || undefined));
            // Create metrics for this custom event
            metricEventsRef.current[event] = measureEvent(event, __assign(__assign({}, data), additionalData.current), options || {});
        }
        // Is the consumer registering a listener for this event?
        if (callback) {
            // Save it as a listener so we can recall it when we track it below
            eventListenersRef.current[event] = callback;
            // Notify the action measurement has started
            callback({ step: 'start', action: event, metric: metricEventsRef.current[event] });
        }
    }, [measureEvent]);
    /**
     * Allows pages to track custom events. Internally it uses the recordMetric function
     * passing the right parameters
     *
     */
    var track = (0, react_1.useCallback)(function (event, error, data, options, onTrackedCallback) {
        // Do we have a client initialized for this metric
        var metric = metricEventsRef.current[event];
        if (metric) {
            var callback = eventListenersRef.current[event];
            if (callback) {
                // Notify the action measurement has started
                callback({ step: 'end', action: event, metric: metricEventsRef.current[event] });
                // Delete the listener if any for this event
                delete eventListenersRef.current[event];
            }
            metric.update(data);
            if (error) {
                recordMetric('error', __assign(__assign({}, data), { type: 'handled_error', error_message: error.message }), event, options, onTrackedCallback);
            }
            else {
                var _a = (0, exports.getResultFromActionData)(data), result = _a.result, error_message = _a.error_message;
                recordMetric(result, __assign(__assign({}, data), { type: (data === null || data === void 0 ? void 0 : data.type) || 'tracked', error_message: error_message }), event, options, onTrackedCallback);
            }
        }
        else {
            LOG.debug('A page attempted to track an action without calling the startAction function first');
        }
    }, [recordMetric]);
    /**
     * Function to allow pages to start measuring custom page actions. Each page has different
     * requirements on what actions it needs to track and can do so by invoking this function
     * in combination with the endAction function below
     *
     * @param {string}   name The action identifier. This is the action_name used by the reporters
     * @param {object}   data The custom data to register for this action
     * @param {function} callback A callback function used to notify consumers on route changes
     * @param {object}   options An object for options to use in transformations or reporters
     *
     */
    var startAction = (0, react_1.useCallback)(function (event, data, callback, options) {
        if (data === void 0) { data = {}; }
        // Make sure consumers are not using any reserved words
        checkReservedWords(data);
        if (typeof event !== 'string' && (event === null || event === void 0 ? void 0 : event.id)) {
            var id = event.id, _a = event.destinations, destinations = _a === void 0 ? undefined : _a;
            measure(id, __assign(__assign({}, data), { destinations: destinations }), callback, options);
            // Save options
            metricsEventsOptionsRef.current[id] = { callback: callback, options: options };
        }
        else if (typeof event === 'string') {
            measure(event, __assign({}, data), callback, options);
            // Save options
            metricsEventsOptionsRef.current[event] = { callback: callback, options: options };
        }
    }, [measure]);
    /**
     * Allows pages to finish measuring custom actions. If an error param is passed in the data,
     * the action is reported as an error instead of success.
     *
     * @param {string} name  The event identifier. This is the action_name used by the reporters
     * @param {object} data  The additional event data
     * @param {boolean} keepAlive  The additional event data
     */
    var endAction = (0, react_1.useCallback)(function (name, data, keepAlive, options, callback) {
        var eventName;
        if (typeof name !== 'string') {
            eventName = name === null || name === void 0 ? void 0 : name.id;
        }
        else {
            eventName = name;
        }
        var _a = (data || {}).error, error = _a === void 0 ? null : _a;
        var initialData;
        if (keepAlive) {
            var metric = metricEventsRef.current[eventName];
            initialData = metric.getData();
        }
        // Make sure consumers are not using any reserved words
        checkReservedWords(data);
        if (error && typeof error === 'string') {
            delete data.error;
            track(eventName, { message: error }, data, options, callback);
        }
        else {
            track(eventName, (error === null || error === void 0 ? void 0 : error.message) ? error : null, data, options, callback);
        }
        if (initialData) {
            // Start measuring again
            var _b = metricsEventsOptionsRef.current[eventName] || {}, options_1 = _b.options, callback_1 = _b.callback;
            startAction(eventName, initialData, callback_1, options_1);
        }
    }, [track, startAction]);
    /**
     * Sends a page action with some optional data. Use this function when you don't require
     * to track duration
     *
     * @param {string} name the action name
     * @param {object} data An object to send with the event (be sure the data is accepted by the reports being used)
     * @param {object} options Additional options that will be sent to the reporter
     */
    var trackAction = (0, react_1.useCallback)(function (event, data, options, callback) {
        if (data === void 0) { data = {}; }
        // Make sure consumers are not using any reserved words
        checkReservedWords(data);
        var _a = (0, exports.getResultFromActionData)(data), result = _a.result, error_message = _a.error_message;
        LOG.debug("".concat(event, " action tracked for => ").concat(data.url || data.screenName || undefined));
        if (typeof event !== 'string' && (event === null || event === void 0 ? void 0 : event.id)) {
            var id = event.id, _b = event.destinations, destinations = _b === void 0 ? undefined : _b;
            trackEvent(id, __assign(__assign(__assign(__assign({}, data), { result: result, error_message: error_message }), additionalData.current), { destinations: destinations }), options, callback);
        }
        else {
            // event itself is the id
            trackEvent(event, __assign(__assign(__assign({}, data), { result: result, error_message: error_message }), additionalData.current), options, callback);
        }
    }, [trackEvent]);
    /**
     * Same as track above but with the only difference that we re-initialize the metrics client again
     * so the consumer can keep tracking events
     */
    var trackKeepAlive = (0, react_1.useCallback)(function (event, error, data) {
        // Do we have a client initialized for this metric
        var metric = metricEventsRef.current[event];
        var initialData = metric.getData();
        track(event, error, data);
        // Start tracking again
        measure(event, initialData);
    }, [track, measure]);
    /**
     * Function to allow consumers to add metadata that is not available when initializing client. A userId/attendeeId
     * is probably a good example
     */
    var updateMetricData = (0, react_1.useCallback)(function (data, options) {
        if (data === void 0) { data = {}; }
        checkReservedWords(data);
        var persist = (options || {}).persist;
        // Save it in memory so we can include them in future actions
        additionalData.current = __assign(__assign({}, additionalData.current), data);
        if (persist) {
            // Only save the data that is provided + what was already there
            setPersistedDataCallback(__assign(__assign({}, getPersistedDataCallback()), data));
        }
    }, []);
    /**
     * Function to allow consumers to get the props that were set as base props during initialization or
     * when the updateMetricsData function is called
     */
    var getBaseProps = (0, react_1.useCallback)(function () {
        return __assign(__assign(__assign({}, getClientBaseProps()), additionalData.current), getPersistedDataCallback());
    }, [getClientBaseProps]);
    /**
     * @deprecated Use startAction instead. This function will no longer be available in the next release
     */
    var measureAction = startAction;
    /**
     * @deprecated Use endAction instead. This function will no longer be available in the next release
     */
    var recordAction = endAction;
    /**
     * @deprecated Use measureAction instead. This function will no longer be available in the next release
     */
    var measureSLI = measureAction;
    /**
     * @deprecated Use recordAction instead. This function will no longer be available in the next release
     */
    var trackSLI = recordAction;
    /**
     * Effect to capture UTM params and persist them so they can be attached
     * as base props in all future actions
     */
    (0, react_1.useEffect)(function () {
        var _a;
        var baseProps = getBaseProps();
        // If this is being executed in the browser we grab it from window.location else check if baseProps has the url
        var url = typeof window !== 'undefined' ? (_a = window.location) === null || _a === void 0 ? void 0 : _a.href : baseProps === null || baseProps === void 0 ? void 0 : baseProps.url;
        var utmParams = (0, sli_metrics_client_1.extractUTMParameters)(url);
        var hasUtm = Object.keys(utmParams).length > 0;
        var now = new Date();
        if (hasUtm) {
            var utmCapturedOn = utmParams.utmCapturedOn || now.toISOString();
            // Update metrics with utm params and persist them in local storage for the active application
            updateMetricData(__assign(__assign({}, utmParams), { utmCapturedOn: utmCapturedOn }), { persist: true });
            // Share utm params with other applications
            (0, sli_metrics_client_1.shareUTMParameters)(__assign(__assign({}, utmParams), { utmCapturedOn: utmCapturedOn }));
        }
    }, [getBaseProps, updateMetricData]);
    return (React.createElement(exports.PageActionsContext.Provider, { value: {
            getBaseProps: getBaseProps,
            updateMetricData: updateMetricData,
            track: track,
            trackAction: trackAction,
            trackKeepAlive: trackKeepAlive,
            startAction: startAction,
            endAction: endAction,
            actionsRef: metricEventsRef.current,
            measureAction: measureAction,
            recordAction: recordAction,
            measureSLI: measureSLI,
            trackSLI: trackSLI
        } }, children));
};
exports.PageActionsProvider = PageActionsProvider;
